import { Component } from 'react';
import cx from 'classnames';
import styles from './../../../styles/home/blackNudge.scss';

interface Props {
  isMobile: boolean;
  closeNudge: Function;
  redirectURL: string;
}
interface State {
  nudgeRequired: boolean;
}

class BlackNudge extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      nudgeRequired: false,
    };
  }
  public componentDidMount = () => {
    const isDeviceCompatiable = /Android|iPhone/i.test(navigator.userAgent);
    if (isDeviceCompatiable) {
      this.setState({ nudgeRequired: true });
    }
  };

  public render() {
    const { nudgeRequired } = this.state;
    const { isMobile, redirectURL } = this.props;

    if (!nudgeRequired || !isMobile) {
      return null;
    }

    return (
      <div id="blackNudge" className={styles['black-nudge']}>
        <div
          onClick={() => this.props.closeNudge()}
          className={cx('small-1', styles['closing-icon'])}
        >
          <span className={styles['black-close']} id="blackClose">
            X
          </span>
        </div>
        <div className="small-1 p0">
          <img
            className={cx('lazyload', styles['black-logo'])}
            loading="lazy"
            src="https://assets1.cleartax-cdn.com/cleartax/images/1620684359_1608301447_balck_icon2.png"
            width="40"
            height="40"
          />
        </div>
        <a href={redirectURL} className={styles['wrapper']}>
          <div className="small-8 text-right">
            <p className={styles['black-title']}>
              Invest in Tax Saving via BLACK APP
            </p>
            <img
              src="https://assets1.cleartax-cdn.com/s/img/2020/12/20050643/small-star.png"
              className="inline-block"
              width="10"
              height="10"
            />
            <img
              src="https://assets1.cleartax-cdn.com/s/img/2020/12/20050643/small-star.png"
              className="inline-block"
              width="10"
              height="10"
            />
            <img
              src="https://assets1.cleartax-cdn.com/s/img/2020/12/20050643/small-star.png"
              className="inline-block"
              width="10"
              height="10"
            />
            <img
              src="https://assets1.cleartax-cdn.com/s/img/2020/12/20050643/small-star.png"
              className="inline-block"
              width="10"
              height="10"
            />
            <img
              src="https://assets1.cleartax-cdn.com/s/img/2020/12/20050755/star-half.png"
              className="inline-block"
              width="10"
              height="10"
            />
            <p className={cx('inline-block', styles['font--10'])}>(1200)</p>
          </div>
        </a>
        <div className="small-2 text-center p0">
          <a href={redirectURL} className={cx('btn', styles['black-btn'])}>
            Install
          </a>
        </div>
      </div>
    );
  }
}

export default BlackNudge;



// WEBPACK FOOTER //
// ./components/homePage/experimental/blackNudge.tsx